import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../../components/tickets/navBar";
import banner from "../../assets/banner.jpg";
import EventCard from "../../components/tickets/eventCard";
import Footer from "../../components/tickets/footer";
import PageLoader from "../../components/pageLoader";
import { getResidencyBySlug } from "../../api/ticketsPlatform/events";
import { useTranslation } from "react-i18next";

export default function ResidencyStorePage() {
  const { residency_name } = useParams();

  const { t } = useTranslation();

  const [residency, setResidency] = useState(null);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchResidency = async () => {
    try {
      setLoading(true);
      const data = await getResidencyBySlug(residency_name);
      setResidency(data);
      setEvents(data.events || []);
    } catch (err) {
      // err
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchResidency();
  }, [residency_name]);

  if (loading) return <PageLoader />;

  return (
    <div className="bg-[#000d09] text-white min-h-screen">
      <Navbar />

      {/* HERO */}
      <div
        className="relative h-[50vh] md:h-[70vh] min-h-[400px] flex items-end justify-center text-center"
        style={{
          backgroundImage: residency?.flyer ? `url(${residency.flyer})` : `url(${banner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundColor: residency?.flyer ? "transparent" : "#000d09",
        }}
      >
        {/* Overlay */}
        <div
          className="absolute inset-0 bg-gradient-to-b 
            from-[#000d09]/10 
            via-[#000d09]/30 
            to-[#000d09]"
        />

        <div className="relative z-10 pb-10 md:pb-14 px-4">
          {residency?.name && (
            <p className="text-green-400 tracking-widest text-xs md:text-sm uppercase">
              {t("events.upcoming")}
            </p>
          )}
          <h1 className="text-3xl md:text-5xl font-bold mt-2 leading-tight">
            {residency?.name}
          </h1>
        </div>
      </div>

      {/* EVENT LIST */}
      <div className="max-w-4xl mx-auto px-4 py-10 space-y-6">
        {events.length > 0 ? (
          events.map((event) => (
            <EventCard key={event.id} event={event} />
          ))
        ) : (
          <div className="text-center py-20">
            <p className="text-white/40 text-lg">{ t("events.noEvents")}</p>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}